import * as Yup from "yup";
import { ContactUsFormFields } from "../types";
import {
  EMAIL_VALIDATION_SCHEMA,
  LENGTH_VALIDATION,
  PHONE_VALIDATION_SCHEMA,
} from "src/constants/formValidation";

export const CONTACT_US_FORM_VALIDATION_SCHEMA = Yup.object().shape({
  [ContactUsFormFields.name]: LENGTH_VALIDATION(0, 100),
  [ContactUsFormFields.email]: EMAIL_VALIDATION_SCHEMA,
  [ContactUsFormFields.phone]: PHONE_VALIDATION_SCHEMA,
  [ContactUsFormFields.country]: Yup.string().required("required"),
  [ContactUsFormFields.role]: Yup.string().required("required"),
  [ContactUsFormFields.howWeCanHelp]: LENGTH_VALIDATION(0, 256),
});
